// How MUCH of the app an item uses: full tracking (tasks, counters,
// maintenance -- today's behavior) or trips-and-logs only (a chartered boat,
// a boat since sold: something whose voyages are worth recording but whose
// maintenance is somebody else's problem).
//
// This is the ONE module allowed to gate features on `TaskPogoItem.tracking`.
// It is deliberately a separate axis from ItemTypes.mjs, whose contract
// guarantees `itemType` gates nothing -- tracking is a user's explicit choice
// about scope, not an inference from what kind of thing the item is (and not
// an inference from "has no tasks yet", which is also true of every freshly
// created tracked item).
//
// FAIL OPEN: null, absent, 'full' and every unrecognized value all mean fully
// tracked. gen2-dev and gen2-prod are independent APIs and prod lags, so a
// value written by a newer dev build must degrade to showing everything, not
// to hiding features. The same reasoning as itemTypeById's Unspecified
// fallback, pointed the other way -- there the safe default is a neutral
// label, here it is the full UI.
//
// Log-only is presentation, never authorization: task and counter pages stay
// reachable by URL, so an item downgraded after collecting tasks keeps its
// data readable, and switching back to Full tracking (the same edit modal,
// clearing the select) is the whole "upgrade a charter to a keeper" story --
// no migration, no data touched.

export const TRACKING_TRIPS = 'trips';

// True only for the explicit log-only marker; see the fail-open rule above.
export function isLogOnly(item) {
  return item?.tracking === TRACKING_TRIPS;
}

// The option list EditForm's `select` branch wants: {id, index, name}.
//
// The leading id-null option is MANDATORY for the selectValueFromId reason
// itemTypeSelects documents -- but unlike Unspecified there, null is a REAL
// meaning here ("Full tracking", the default), so it reads as the first
// choice rather than as "nobody has set this".
export function trackingSelects() {
  return [
    { id: null, index: 0, name: 'Full tracking' },
    { id: TRACKING_TRIPS, index: 1, name: 'Trips & logs only' },
  ];
}
